import { render } from "./Register.vue?vue&type=template&id=fefb5a30&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=fefb5a30&lang=css"
import "./Register.vue?vue&type=style&index=1&id=fefb5a30&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fefb5a30"]])

export default __exports__